export default __webpack_public_path__ + "MentiaLogo2024.jpg";